import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button, Snackbar } from "@mui/material";
import { resendVerificationEmail } from "../services/User";

/**
 * Persistent banner shown when user's email is not verified.
 * Placed at the top of the dashboard layout.
 */
const VerificationBanner = () => {
  const { user } = useSelector((state) => state.user);
  const [sending, setSending] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Don't render if verified, admin, or no user
  if (!user || user.emailVerified || user.role === "ADMIN") return null;

  const handleResend = async () => {
    setSending(true);
    try {
      const res = await resendVerificationEmail();
      setSnack({
        open: true,
        message: res.message || "Verification email sent!",
        severity: "success",
      });
    } catch (err) {
      const msg =
        err.response?.data?.message || "Failed to send verification email";
      setSnack({ open: true, message: msg, severity: "error" });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Alert
        severity="warning"
        sx={{ borderRadius: 0, mb: 0 }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleResend}
            disabled={sending}
          >
            {sending ? "Sending…" : "Resend email"}
          </Button>
        }
      >
        Your email is not verified. Please check your inbox to verify your
        account.
      </Alert>
      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snack.severity}
          variant="filled"
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VerificationBanner;
